// @flow
import React from 'react';
import {TextInput} from 'sail/Input';
import {CaptionMono} from 'sail/Text';
import {dimensions} from '../StyleHelpers';

type IntegerInputProps = {|
  field_id: string,
  param_key: string,
  required: boolean,
  inputType: string,
  params: Object,
  setParams: (Object) => void,
|};

const handleParamChange = (param_key, value, params, setParams) => {
  if (value) {
    // TODO: validate that value is an int and show error if not
    setParams({...params, [param_key]: parseInt(value, 10)});
  } else {
    const {[param_key]: removed, ...newParams} = params;
    setParams(newParams);
  }
};

export const IntegerInput = ({
  field_id,
  param_key,
  required,
  inputType,
  params,
  setParams,
}: IntegerInputProps) => {
  return (
    <TextInput
      style={{height: dimensions.height}}
      width={dimensions.width}
      radius="none"
      key={field_id}
      id={field_id}
      type="number"
      onChange={(value) =>
        handleParamChange(param_key, value, params, setParams)
      }
      end={{
        'aria-label': `${inputType}`,
        content: <CaptionMono color="gray">{`${inputType}`}</CaptionMono>,
      }}
      value={params[param_key] ? params[param_key] : ''}
      clearable
      onClear={() => handleParamChange(param_key, '', params, setParams)}
    />
  );
};
